import { useEffect, useState } from "react";
import { RiBehanceFill, RiGithubFill, RiLinkedinBoxFill } from "react-icons/ri";
import Tilty from "react-tilty";
import Particles from "react-tsparticles";
import styled from "styled-components";
import Logo from "../../atoms/Logo";
import particlesOptions from "./particles.json";

const Hero = () => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setHeight(window.innerHeight);
    };

    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  const HeroWrapper = styled.section`
    position: relative;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: ${({ height }) => `${height}px`};
    margin: 0 auto;
    background: #002366;
    #tsparticles > canvas {
      position: absolute !important;
    }
    .title {
      margin-bottom: 0;
    }
    .subtitle {
      margin-top: 1.875rem;
      font-size: 1rem;
      font-weight: 600;
      text-align: center;
      @media (min-width: 64rem) {
        font-size: 2rem;
      }
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(175deg, transparent 0%, #002366 75%);
      width: 100%;
      height: 100%;
    }
  `;

  const HeroContent = styled.section`
    position: relative;
    z-index: 1;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;

  const LinkList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    padding: 1.25rem 0;
    font-size: 0.75rem;
    font-weight: 600;
  `;
  const IconLink = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    text-decoration: none;
    gap: 0.375rem;
    padding: 0.375rem;
    min-width: 4.5rem;
    aspect-ratio: 1 / 1;
    border-radius: 100%;
    background: radial-gradient(circle, #002366 0%, transparent 100%);
    transition: all 750ms cubic-bezier(0.2, 0.9, 0.3, 1.5);
    &:hover,
    &:focus {
      background-color: #170768;
      backdrop-filter: blur(4px);
      box-shadow:
        inset 1px 1px 1px 0 rgba(255, 255, 255, 0.2),
        inset -1px -1px 1px 1px rgba(255, 255, 255, 0.2),
        0 1px 2px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.1);
    }
    &:active {
      color: #9eed42;
    }
    span {
      margin-bottom: 0.375rem;
    }
    .icon {
      width: 1.25rem;
      height: 1.25rem;
    }
  `;

  return (
    <HeroWrapper height={height}>
      <HeroContent>
        <Tilty
          perspective={1000}
          scale={1.01}
          gyroscope={true}
          reset={true}
          style={{
            transformStyle: "preserve-3d",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Logo animated={true} className="logo" />
          <h2 className="subtitle" style={{ transform: "translateZ(30px)" }}>
            {"Front-end Developer"}
            <br />
            {"& UI/UX Designer"}
          </h2>
        </Tilty>
        <LinkList>
          {/* <IconLink
            href={CV}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="External Link"
          >
            <RiAttachment2 className="icon" />
            <span>Curriculum</span>
          </IconLink> */}
          <IconLink
            href="https://www.linkedin.com/in/samuel-bart/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="External Link"
          >
            <RiLinkedinBoxFill className="icon" />
            <span>Linkedin</span>
          </IconLink>
          <IconLink
            href="https://www.behance.net/samuelbart"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="External Link"
          >
            <RiBehanceFill className="icon" />
            <span>Behance</span>
          </IconLink>
          <IconLink
            href="https://github.com/bartsam/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="External Link"
          >
            <RiGithubFill className="icon" />
            <span>GitHub</span>
          </IconLink>
        </LinkList>
      </HeroContent>
      <Particles options={particlesOptions} />
    </HeroWrapper>
  );
};

export default Hero;
